import React from 'react';
import { BRAND_ORANGE } from '../../../../styles/portalTheme';
import {
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  Typography,
} from '@mui/material';

const MenuPrefillImportDialog = ({
  open,
  fileName,
  existingDishCount = 0,
  onClose,
  onAppend,
  onReplace,
}) => (
  <Dialog open={open} onClose={onClose} maxWidth="xs" fullWidth>
    <DialogTitle sx={{ fontWeight: 700 }}>Import menu from file</DialogTitle>
    <DialogContent>
      <Typography variant="body2" color="text.secondary" sx={{ mb: 1 }}>
        {fileName ? (
          <>
            File: <strong>{fileName}</strong>
          </>
        ) : null}
      </Typography>
      <Typography variant="body2" color="text.secondary">
        {existingDishCount > 0
          ? `This menu already has ${existingDishCount} dish${existingDishCount === 1 ? '' : 'es'} with content. How would you like to apply the imported data?`
          : 'How would you like to apply the imported data?'}
      </Typography>
    </DialogContent>
    <DialogActions sx={{ flexDirection: 'column', alignItems: 'stretch', px: 3, pb: 2.5, gap: 1 }}>
      <Button
        variant="contained"
        onClick={onAppend}
        sx={{
          textTransform: 'none',
          fontWeight: 600,
          bgcolor: BRAND_ORANGE,
          boxShadow: 'none',
          '&:hover': { bgcolor: 'primary.dark', boxShadow: 'none' },
        }}
      >
        Append new records
      </Button>
      <Button
        variant="outlined"
        onClick={onReplace}
        sx={{
          textTransform: 'none',
          fontWeight: 600,
          color: BRAND_ORANGE,
          borderColor: BRAND_ORANGE,
          '&:hover': { borderColor: 'primary.dark', bgcolor: 'rgba(224, 104, 10, 0.04)' },
        }}
      >
        Replace existing records
      </Button>
      <Button onClick={onClose} sx={{ textTransform: 'none', color: 'text.secondary' }}>
        Cancel
      </Button>
    </DialogActions>
  </Dialog>
);

export default MenuPrefillImportDialog;
